import { render } from "./PersonalSite.vue?vue&type=template&id=1c68f4b6"
import script from "./PersonalSite.vue?vue&type=script&lang=js"
export * from "./PersonalSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__